import { LeadPopUpButton } from '@/components/shared/lead/LeadPopUpButton';
import styles from './WhyPartnerWithUs.module.css';
import Image from "next/image";
import { ElemenetType } from '@/lib/constants';
export function WhyPartnerWithUs() {
    return (
        <section className="section bgLigtgray">
            <div className="containerFull">
                <h2 className="font26 f500 text000 mb20 textCenter fontSM20">Why Partner With<span className="textpink"> Us?</span></h2>
                <span className={`font16 comPletmainbox textCenter ${styles.disPlyblok}`}>Experience distinguished designs and transparent pricing with the best interior design company in Dubai. </span>
                <div className={styles.whyChowesmbox}>
                    <div className={styles.whyChoestiles}>
                        <Image width={62} height={62} className="img-responsive" src="assets/images/madetoorder.svg" alt="madetoorder" />
                        <h3>Made to Order</h3>
                    </div>
                    <div className={styles.whyChoestiles}>
                        <Image width={62} height={62} className="img-responsive" src="assets/images/lowestPrice.svg" alt="lowestPrice" />
                        <h3>Lowest Prices Guaranteed</h3>
                    </div>
                    <div className={styles.whyChoestiles}>
                        <Image width={62} height={62} className="img-responsive" src="assets/images/qcEveryStep.svg" alt="qcEveryStep" />
                        <h3>QC At Every Step</h3>
                    </div>
                    <div className={styles.whyChoestiles}>
                        <Image width={62} height={62} className="img-responsive" src="assets/images/timeDelivery.svg" alt="timeDelivery" />
                        <h3>Timely Delivery Assurance</h3>
                    </div>
                    <div className={styles.whyChoestiles}>
                        <Image width={62} height={62} className="img-responsive" src="assets/images/tenYearsWarr.svg" alt="tenYearsWarr" />
                        <h3>11-Year Warranty</h3>
                    </div>
                </div>
                <LeadPopUpButton ElemenetType={ElemenetType.button} ButtonClass={`btn btnPrimery btnCenter`}>Book Free Consultation</LeadPopUpButton>
            </div>
        </section>
    )
}